import React from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { PRODUCT_IMAGES } from "../../../../../../utils/imagesMap"
import CheckmarkIcon from "../../../../../../assets/icons/wild/checkmark-icon.svg"

export const bearerToken = process.env.GATSBY_MAGENTO_API_BEARER_TOKEN
export const envUrl = process.env.GATSBY_MAGENTO_URL
export const DEVMODE = process.env.GATSBY_DEVMODE === "1"

export const ADDED = `Item added to cart`
export const COREINFO = `Hair Growth Nutraceutical`
export const ERRORMSG = `Error getting cart quote. Please proceed to cart.`
export const ERRORMSG2 = `Error removing original product. Please proceed to cart.`
export const ERRORMSG3 = `Error adding product to cart. Please proceed to cart.`
export const HEADER1 = `Your foundation for hair growth.`
export const HEADER2 = `Maximize your hair health potential.`
export const LABELVIEW = "View Cart"
export const LABELCHECKOUT = "Checkout"
export const LABELREMOVE = `Remove`
export const DELIVERY3 = `A 3-month supply delivered every 3 months.`
export const DELIVERY3REFILLS = `A 3-month supply with refills delivered every 3 months.`
export const DELIVERYOT = `One-Time Purchase`
export const OT = `One-Time`
export const SUB3M = `3-Month Subscription`
export const SUB1M = `Monthly Subscription`
export const TOTAL = `Today’s Total`
export const TOTALPLAN = `Hair Health Plan`
export const ATC = `Add to Cart`
export const ATCPLAN = `Add to Subscription`
export const MON1 = `month`
export const MON3 = `3 Month`
export const SERUMDESCRIPTION = `Pair Hair Serum with your Hair Growth Nutraceutical to support visibly thicker, stronger hair from both the inside and out.`
export const FHKSML_SOURCE = `masterbrand_fhk_upgrade_modal`
export const HS_SOURCE = `masterbrand_hs_upgrade_modal`
export const MODAL_HS = `Masterbrand HS 1oz Upgrade Modal`
export const MODAL_FHKSML = `Masterbrand FHK Upgrade Modal`

export const HAIRSERUMSML_PROPS = {
  image: { url: PRODUCT_IMAGES.HAIRSERUMSML.label2 },
  info: "Scalp Care - 1oz",
  name: "Hair Serum",
  old_price: 49,
  price: 44,
  product_category: "Scalp Support",
  product_gender: "All",
  purchase_type: "Growthplan 1",
  sku: "HAIRSERUMSML-N01",
  variant: "Single Bottle",
  billing_interval: null,
  shipping_interval: null,
  subscription_type: null,
}

export const FHKSML_PROPS = {
  billing_interval: "1 month",
  core_category: "Multi-Category Kits",
  image: { url: PRODUCT_IMAGES.WOMGSML1.label1 },
  name: "Women + Hair Serum 1oz",
  old_price: 137,
  price: 123,
  product_category: "Multi-Category Kits",
  product_gender: "Women",
  purchase_type: "Hair Growth Kit",
  sku: "WOMGSML1-S01",
  shipping_interval: "1 month",
  subscription_type: "1 month",
  variant: "Monthly Delivery",
}

export const FHKSML_PROPS_MAP = {
  "WOM1-S01": {
    name: "Women + Hair Serum 1oz",
    sku: "WOMGSML1-S01",
  },
  "BAL1-S01": {
    name: "Women's Balance + Hair Serum",
    sku: "BALGSML1-S01",
  },
  "BAL3-S01": {
    name: "Women's Balance + Hair Serum",
    sku: "BALGSML3-S01",
    price: 348,
    billing_interval: "3 month",
    shipping_interval: "3 month",
    subscription_type: "3 month",
  },
  "VEG1-S01": {
    name: "Women's Vegan + Hair Serum",
    sku: "VEGGSML1-S01",
  },
  "POS1-S01": {
    name: "Postpartum + Hair Serum",
    sku: "POSGSML1-S01",
  },
}

export const Rows = styled(Flex)`
  background: #fff;
  flex-direction: column;
  border-radius: 8px;

  hr {
    color: #c8d2d1;
  }
`
export const ButtonContent = styled(Flex)`
  a,
  button {
  }

  @media screen and (max-width: 767px) {
    width: calc(100% + 16px);
    margin-left: -8px;
  }
`
export const AddedContent = styled(Flex)`
  align-items: center;
  gap: 8px;

  svg {
    path {
      fill: #008078;
    }
  }
`

export const AddedRow = (
  <AddedContent>
    <Box width={[20]}>
      <CheckmarkIcon />
    </Box>
    <Box>
      <TextElementNova
        text={ADDED}
        className={`text-nova-brand-primary-80 Body-20-Dia-Strong`}
      />
    </Box>
  </AddedContent>
)
